import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgxMaskPipe } from 'ngx-mask';
import { ToastrService } from 'ngx-toastr';
import { AnalyticsService } from '../../../services/analytics.service';
import { TopClienteApi } from '../../../models/analytics.model';

@Component({
  selector: 'app-top-clientes-chart',
  standalone: true,
  imports: [CommonModule, CurrencyPipe, DatePipe, NgxMaskPipe],
  templateUrl: './top-clientes-chart.component.html',
  styleUrls: ['./top-clientes-chart.component.css']
})
export class TopClientesChartComponent implements OnInit {
  dados: TopClienteApi[] = [];
  isLoading = true;
  hasError = false;

  constructor(
    private analyticsService: AnalyticsService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.carregarDados();
  }

  carregarDados(): void {
    this.isLoading = true;
    this.hasError = false;

    this.analyticsService.getTopClientes().subscribe({
      next: (data) => {
        this.dados = (data ?? []).slice(0, 10);
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.isLoading = false;
        this.hasError = true;
        this.toastr.error('Erro ao carregar o top de clientes.');
        this.cdr.detectChanges();
      }
    });
  }
}
